import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=242e9dfc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e9dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('242e9dfc')) {
      api.createRecord('242e9dfc', component.options)
    } else {
      api.reload('242e9dfc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=242e9dfc&scoped=true&", function () {
      api.rerender('242e9dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b5iJXE26a1kS/JS/comp/Accordion.vue"
export default component.exports